/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Коллекция для дополнительных телефонов пользователя
   */
  app.UserPhones = app.Collection.extend({
    
    model: app.UserPhone,
    
    url: app.entryScriptName + '/api/v3/user-phone',
    
    getAutoIncrementId: function () {
      var maxId = this.max(function (model) {
          return model.id;
        }).id,
        id;
      
      if (!maxId) {
        id = 1;
      } else {
        id = maxId + 1;
      }
      
      return id;
    }
    
  });
  
})();

}.call(window));